export const LOCATIONS = [
  { key: 'rural_area', value: 'rural_area' },
  { key: 'urban_area', value: 'urban_area' },
  { key: 'n/a', value: 'n/a' }
];
